export const DEPOSITO_STORE = 'deposito';
